import {JsonProperty} from '@hyperloris/tyson';

export class ConversionRate {
  @JsonProperty()
  conversionRate: number = undefined;
}
